import { render, staticRenderFns } from "./adminReports.vue?vue&type=template&id=767eca74&scoped=true"
import script from "./adminReports.vue?vue&type=script&lang=js"
export * from "./adminReports.vue?vue&type=script&lang=js"
import style0 from "./adminReports.vue?vue&type=style&index=0&id=767eca74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767eca74",
  null
  
)

export default component.exports